import {View} from 'MWC';
import tpl from '../templates/Table.jsx';
import React, {useRef} from 'react';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            height: 0
        };
        this.toggleMode = this.toggleMode.bind(this);
        this.myRef = React.createRef();
        this.questionsRef = React.createRef();
    }

    componentDidUpdate() {
        if (this.myRef.current.clientHeight !== this.state.height) {
            this.setState({height: this.myRef.current.clientHeight});
        }
        this.addListenerForLink();
    }

    componentDidMount() {
        this.addListenerForLink();
    }

    addListenerForLink() {
        const elem = document.getElementById('questionsRef');
        if (elem && !elem.hasAttribute('listener')) {
            elem.addEventListener('click', () => {
                elem.setAttribute('listener', 'true');
                this.toggleMode('questions');
            });
        }
    }

    componentWillUnmount() {
        const elem = document.getElementById('questionsRef');
        if (elem) {
            elem.removeEventListener('click', () => this.toggleMode('questions'));
        }
    }

    toggleMode = value => {
        if (this.props.toggle) {
            this.props.toggle(value);
        }
    };

    static defaultProps = {
        title: 'Put your title here',
        id: ''
    };
}
